import { motion } from 'framer-motion';
import { Beef, Factory, Home, RefreshCw, Route, Sprout, Trees, Users, Wheat } from 'lucide-react';
import { Section, SectionTitle } from '@/components/landing/Section';

const CARDS = [
  {
    icon: Home,
    title: 'Estancias',
    text: 'Vigilancia perimetral y control de accesos para propiedades rurales extensas.',
  },
  {
    icon: Wheat,
    title: 'Silos',
    text: 'Protección de granos, maquinaria y depósitos contra robo y vandalismo.',
  },
  {
    icon: Users,
    title: 'Personal especializado',
    text: 'Guardias entrenados para entornos rurales y logística agroindustrial.',
  },
];

const TILES = [
  { icon: Sprout, label: 'Sector Agrícola' },
  { icon: Beef, label: 'Ganadería' },
  { icon: Factory, label: 'Agroindustria' },
  { icon: Trees, label: 'Forestal' },
  { icon: Route, label: 'Rondas Móviles' },
  { icon: RefreshCw, label: 'Turnos Rotativos' },
];

export function Agro() {
  return (
    <Section id="agro">
      <SectionTitle
        kicker="Sector Agropecuario"
        kickerClassName="text-emerald-400/80"
        subtitle="Soluciones de seguridad adaptadas a la realidad del agro paraguayo."
      >
        Protegemos el campo paraguayo
      </SectionTitle>
      <div className="grid gap-6 md:grid-cols-3">
        {CARDS.map((card, i) => {
          const Icon = card.icon;
          return (
            <motion.div
              key={card.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              whileHover={{ y: -4 }}
              className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-6 transition-colors hover:border-emerald-400/40 hover:bg-white/[0.04]"
            >
              <Icon className="h-9 w-9 text-emerald-400" strokeWidth={1.5} aria-hidden />
              <h3 className="mt-4 text-lg font-semibold">{card.title}</h3>
              <p className="mt-2 text-sm text-slate-400">{card.text}</p>
            </motion.div>
          );
        })}
      </div>
      <ul className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3">
        {TILES.map((tile) => {
          const Icon = tile.icon;
          return (
            <li
              key={tile.label}
              className="flex items-center gap-3 rounded-xl border border-white/[0.06] bg-white/[0.02] px-4 py-3 text-sm text-slate-300 transition-colors hover:bg-white/[0.04]"
            >
              <Icon className="h-5 w-5 shrink-0 text-emerald-400" strokeWidth={1.5} aria-hidden />
              {tile.label}
            </li>
          );
        })}
      </ul>
    </Section>
  );
}
